<template>
    <div class="menu">
        <div class="logo-box">
            <img src="../assets/logon.png" alt="">
        </div>

        <div class="menu-box">
            <div class="item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Trang chủ </div>
            <div class="item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">Công nghệ</div>
            <div class="item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">Triển lãm</div>
            <div class="item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">Phục vụ</div>
            <div class="item" :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">Tham khảo ý kiến</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "Projects" }); break;
                case 4: this.$router.push({ path: "Services" }); break;
                case 5: this.$router.push({ path: "ContactUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 40px;
    width: 400px;
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.1);

    .logo-box {
        font-weight: 500;
        font-size: 24px;
        color: #333;
        background: #FFFFFF;
        font-weight: bold;
    }

    .menu-box {
        font-size: 24px;
        font-weight: 500;
        color: #333;
        cursor: pointer;
        margin-top: 180px;

        .item {
            margin-top: 47px;
        }
    }

    .select {
        color: #3BA9F6;
        font-weight: bolder;
    }
}
</style>